import FormInputPassword from "components/FormInputPassword";
import {
  IFormPassword,
  IFormPasswordProps,
  formPasswordSchema,
} from "./Form.config";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "assets/logo_verify.svg";
import { zodResolver } from "@hookform/resolvers/zod";

/**
 * Form to set password to new user
 */

export const Form = ({ onSubmit, isLoading }: IFormPasswordProps) => {
  const methods = useForm<IFormPassword>({
    resolver: zodResolver(formPasswordSchema),
  });

  const onSubmitHandler: SubmitHandler<IFormPassword> = ({
    password,
  }: IFormPassword) => {
    onSubmit(password);
  };

  return (
    <>
    <Box
    sx={{
      width: "40%",
      marginBottom: "3rem",
      "@media (min-width:900px)": {
        width: "90%", // Para md
      },
      "@media (min-width:1200px)": {
        width: "80%",
      },
      "@media (min-width:1536px)": {
        width: "70%", // Para xl
      },
    }}
  >
    <img src={logo} className="img-responsive" alt="Logo" />
  </Box>
  <Box sx={{ width: "100%" }}>
      <Typography
         component="h1"
         color="primary"
         sx={{
           fontStyle: "normal",
           fontWeight: 600,
           lineHeight: "1.8125rem",
           width: "100%",
           mb: ".3rem",
           fontSize: { xs: "1.4rem", xl: "1.4rem" },
         }}>
        Verificar usuario
      </Typography>
      <Typography
        variant="body1"
        component="h2"
        sx={{
          color: "#A7ABBB",
          mb: 4,
          fontSize: { xs: ".8rem", xl: ".8rem" },
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "0.9375rem" /* 93.75% */,
        }}
      >
        Introduce y confirma una nueva contraseña para iniciar sesión con tu
        cuenta
      </Typography>
      <FormProvider {...methods}>
        <Box
          component="form"
          onSubmit={methods.handleSubmit(onSubmitHandler)}
          noValidate
          autoComplete="off"
          width="100%"
        >
          <FormInputPassword name="password" label="Contraseña" sx={{
                  mb: 2,
                  ".MuiTypography-body2": {
                    fontWeight: 600,
                    fontSize: ".9rem",
                    fontStyle: "normal",
                    lineHeight: "1.8125rem",
                  },
                  ".MuiInput-root": {
                    fontSize: ".9rem",
                    padding: 0,
                    height: "32px",
                    lineHeight: "1.8125rem",
                    color: "#718096",
                  },
                }} />
          <FormInputPassword
            name="passwordConfirm"
            label="Confirmar contraseña"
            sx={{
              mb: 2,
              ".MuiTypography-body2": {
                fontWeight: 600,
                fontSize: ".9rem",
                fontStyle: "normal",
                lineHeight: "1.8125rem",
              },
              ".MuiInput-root": {
                fontSize: ".9rem",
                padding: 0,
                height: "32px",
                lineHeight: "1.8125rem",
                color: "#718096",
              },
            }}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            <Button
              variant="contained"
              sx={{ mt: 3, width: "100%" , fontSize: "1.1rem"}}
              disableElevation
              type="submit"
            >
              Registrar Contraseña
            </Button>
          </Box>
        </Box>
      </FormProvider>
    </Box>
    </>
  );
};
